import { render, staticRenderFns } from "./updateDocumentType.vue?vue&type=template&id=8e5a13e4&"
import script from "./updateDocumentType.vue?vue&type=script&lang=js&"
export * from "./updateDocumentType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports